<script setup>
import { ref, computed } from 'vue';
import { useFieldsStore } from '@/stores/storeFieldData';
import { useValidation } from '@/utils/useValidataion';

const storeField = useFieldsStore();

const value = defineModel();
const errorText = ref(null)

const heightErrorText = computed(() => {
    if (errorText.value) {
        return errorText.value.offsetHeight;
    }
})

const { validation, isValid, isTouched, textError } = useValidation(value)

const isPassword = ref(false);
const togglePassword = () => isPassword.value = !isPassword.value;

defineProps({
   
    stateKey: {
        type: String,
    },
    placeholder: {
        type: String,
        default: ''
    },
    required: {
        type: Boolean,
    },
    responseError: {
        type: Object, 
        default: () => ({ active: false, text: '' })
    }
})

</script>
<template>
    <label :class="['input']"> 
        <div class="input__holder">
            <button class="input__password-btn" @click="togglePassword" type="button">
                <svg width='24' height='24'><use :href="isPassword ? '#eye_closed' : '#eye'"></use></svg>
            </button>
            <input 
                :type="isPassword ? 'text' : 'password'"
                :placeholder="placeholder"
                :required="required"
                :class="['input__field', isTouched && (isValid ? 'valid' : 'not-valid') ]"
                @input="storeField.updateFields(stateKey, 'title', value), validation(stateKey)"  
                @blur="validation(stateKey)"
                v-model="value"             
            >
            <span class="input__title"><slot></slot></span>
        </div>             
        
        <Transition mode="out-in">
            <span v-if="!!textError" ref="errorText" class="input__error" :style="{ bottom: `${(heightErrorText + 10) * -1}px` }">{{ textError }}</span>
        </Transition>
        
    </label>
</template>
<style lang='scss' scoped>

input[type="password"] {
    // font-family: auto;
}

.v-enter-active,
.v-leave-active {
    transition: all 0.25s ease-out;
}

.v-enter-from{
    opacity: 0;
  transform: translate(-50%, 10px);
}
.v-leave-to {
  opacity: 0;
  transform: translate(-50%, 10px);
}

</style>